import type { RouteRecordRaw } from 'vue-router';

export const cTEMA_ESTOQUE_ROUTES = {
  //Raiz do módulo
  name: 'TemaEstoque',
  path: 'estoque',
  component: () => import('@/modules/temas/tema-estoque/LayoutTemaEstoque.vue'),

  DisponibilidadeEstoque: {
    name: 'DisponibilidadeEstoqueTemaEstoque',
    path: 'disponibilidade',
    component: () =>
      import('@/modules/temas/tema-estoque/pages/disponibilidade-estoque/DisponibilidadeEstoqueTemaEstoque.vue'),
  },

  ConsumoDeMaterial: {
    name: 'ConsumoDeMaterialTemaEstoque',
    path: 'consumo-de-material',
    component: () => import('@/modules/temas/tema-estoque/pages/consumo-de-material/ConsumoDeMaterialTemaEstoque.vue'),
  },

  EstoqueMinimoMaximoCritico: {
    name: 'EstoqueMinimoMaximoCriticoTemaEstoque',
    path: 'minimo-maximo-critico',
    component: () =>
      import(
        '@/modules/temas/tema-estoque/pages/estoque-minimo-maximo-critico/EstoqueMinimoMaximoCriticoTemaEstoque.vue'
      ),
  },

  Personalizado: {
    path: 'personalizado',
    name: 'PersonalizadoTemaEstoque',

    Gerenciador: {
      path: 'gerenciador',
      name: 'GerenciadorPersonalizadoTemaEstoque',
      component: () =>
        import('@/modules/temas/tema-estoque/pages/personalizado/GerenciadorPersonalizadoTemaEstoque.vue'),
    },

    Dashboard: {
      props: true,
      path: 'dashboard/:idMenu?',
      name: 'DashboardPersonalizadoTemaEstoque',
      component: () =>
        import('@/modules/temas/tema-estoque/pages/personalizado/LayoutDashboardPersonalizadoTemaEstoque.vue'),
    },
  },
};

export const rotasTemaEstoque: Array<RouteRecordRaw> = [
  {
    path: cTEMA_ESTOQUE_ROUTES.path,
    name: cTEMA_ESTOQUE_ROUTES.name,
    component: cTEMA_ESTOQUE_ROUTES.component,
    children: [
      {
        name: cTEMA_ESTOQUE_ROUTES.DisponibilidadeEstoque.name,
        path: cTEMA_ESTOQUE_ROUTES.DisponibilidadeEstoque.path,
        component: cTEMA_ESTOQUE_ROUTES.DisponibilidadeEstoque.component,
      },

      {
        name: cTEMA_ESTOQUE_ROUTES.ConsumoDeMaterial.name,
        path: cTEMA_ESTOQUE_ROUTES.ConsumoDeMaterial.path,
        component: cTEMA_ESTOQUE_ROUTES.ConsumoDeMaterial.component,
      },

      {
        name: cTEMA_ESTOQUE_ROUTES.EstoqueMinimoMaximoCritico.name,
        path: cTEMA_ESTOQUE_ROUTES.EstoqueMinimoMaximoCritico.path,
        component: cTEMA_ESTOQUE_ROUTES.EstoqueMinimoMaximoCritico.component,
      },

      {
        name: cTEMA_ESTOQUE_ROUTES.Personalizado.name,
        path: cTEMA_ESTOQUE_ROUTES.Personalizado.path,
        redirect: { name: cTEMA_ESTOQUE_ROUTES.Personalizado.Gerenciador.name },
        children: [
          {
            name: cTEMA_ESTOQUE_ROUTES.Personalizado.Gerenciador.name,
            path: cTEMA_ESTOQUE_ROUTES.Personalizado.Gerenciador.path,
            component: cTEMA_ESTOQUE_ROUTES.Personalizado.Gerenciador.component,
          },

          {
            name: cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.name,
            path: cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.path,
            props: cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.props,
            component: cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.component,
          },
        ],
      },
    ],
  },
];
